import React from "react";
import { getYear } from "../utils/formatTime";

function footer() {
  return (
    <footer role="contentinfo" aria-label="Footer" className="dashboard-footer">
      <div className="text-color footer p-2 text-center footer-container text-gray">
        {` Copyright © ${getYear()} by Broward Partnerships For Kids. All Rights Reserved.`}
      </div>
    </footer>
  );
}

export default footer;
